import { isMobile } from '../helpers/isMobile';
import { Select } from './select';
import { eventKeyCodes } from '../helpers/eventKeyCodes'

export class MobileNav {
  constructor() {
    this.isInited = false;
    this.isActive = false;
    this.isLastFocusedElement = false;
    this.focusableElements = $('.js-mobile-menu-container').find('a, button, input, textarea, span').toArray();
    this.lastFocusableElement = this.focusableElements[this.focusableElements.length - 1];

    if (isMobile() && !this.isInited) {
      this.init();
    }
    $(window).on('resize', () => {
      if (!$(document.activeElement).is('input, textarea, select')) {
        this.onResize();
      }
    });
  }

  onResize() {
    if (this.isInited) {
      $('.js-mobile-header-changeLang').select2('close');
    }

    if (isMobile() && !this.isInited) {
      this.init();
    } else {
      this.toggle('deactivate');
    }
  }

  toggle(mode) {
    const shouldRestoreFocus = mode !== 'deactivate' || this.isActive;

    if (mode && mode === 'deactivate') {
      this.isActive = false;
      this.updateTabIndexForMenu(false);
      this.updateHeaderTabIndex(false);
    } else {
      this.isActive = !this.isActive;
      this.updateTabIndexForMenu(true);
      this.updateHeaderTabIndex(true);
    }
    $('body').toggleClass('mobile-nav--is-active', this.isActive);
    $('.js-mobile-menu-trigger').attr('aria-expanded', this.isActive);

    if (shouldRestoreFocus) {
      $('.js-mobile-menu-trigger').focus();
    }
  }

  onChangeCountry(event) {
    if (event.target.value) {
      window.location.replace(event.target.value);
    }
  }

  onMainNavItemClick(event) {
    if (isMobile()) {
      // Disable navigating away if the main nav item is clicked on the mobile.
      event.preventDefault();
      const $el = $(event.currentTarget);
      const isExpanded = $el.attr('aria-expanded') === 'true';
      $el.attr('aria-expanded', !isExpanded);
    }
  }

  updateHeaderTabIndex(isOpen) {
    if (isOpen) {
      $('.js-header-logo').attr('tabindex', '-1');
      $('.js-search-header').attr('tabindex', '-1');
    } else {
      $('.js-header-logo').removeAttr('tabindex');
      $('.js-search-header').attr('tabindex', '0');
    }
  }

  updateTabIndexForMenu(isOpen) {
    this.focusableElements.forEach(el => {
      const $el = $(el);

      if (isOpen) {
        $el.removeAttr('tabindex');
        $('.select2-selection.select2-selection--single').attr('tabindex', '0');
      } else {
        $el.attr('tabindex', '-1');
        $('.select2-selection.select2-selection--single').attr('tabindex', '-1');
      }
    });
  }

  resetMenu() {
    this.updateTabIndexForMenu(false);
    this.updateHeaderTabIndex(false);
    this.isActive = false;
    $('body').removeClass('mobile-nav--is-active');
  }

  init() {
    this.isInited = true;
    this.updateTabIndexForMenu(false);

    $('.js-mobile-menu-trigger').on('click', () => this.toggle());
    $('.js-menu-item-main-link').on('click', event => this.onMainNavItemClick(event));
    $(document).on('click', '.mobile-nav--is-active .js-mobile-backdrop',
      () => this.toggle('deactivate'));

    const $mobileChangeCountry = $('.js-mobile-header-changeLang');
    $mobileChangeCountry.select2(Select.getSelectConfig($mobileChangeCountry));
    $mobileChangeCountry.on('change', event => this.onChangeCountry(event));

    const $mobileChangeCountryFooter = $('.js-mobile-footer-changeLang');
    $mobileChangeCountryFooter.select2(Select.getSelectConfig($mobileChangeCountryFooter));
    $mobileChangeCountryFooter.on('change', event => this.onChangeCountry(event));

    $(document).on('focus', '*', event => {
      event.stopPropagation();
      let isFocusInsideMenu = $('.js-mobile-menu-container').has(event.target).length > 0;
      let isFocusOnMenuTrigger = $(event.target).is('.js-mobile-menu-trigger') && $('body').hasClass('mobile-nav--is-active');

      if (!isFocusInsideMenu && !isFocusOnMenuTrigger) {
        this.resetMenu();
      }

      if (this.isLastFocusedElement) {
        this.isLastFocusedElement = false;
        $('.js-header-logo').trigger('focus');
      }

      if (isFocusInsideMenu && event.target === this.lastFocusableElement) {
        this.isLastFocusedElement = true;
      }
    });

    $(document).on('keydown', event => {
      if (event.keyCode === eventKeyCodes.escape && $('body').hasClass('mobile-nav--is-active')) {
        this.resetMenu();
        $('.js-mobile-menu-trigger').trigger('focus');
      }
    });
  }
}
